module.exports = __webpack_public_path__ + "static/media/val-vesa.7af098f1.jpg";